import { useTranslation } from '../../../hooks/useNavConfig';
import getTrainingAndServicesLink from '../../../utils/getTrainingAndServicesLink';
import { AccountExtraLink } from './AccountExtrasLink';
import { jsx as _jsx } from "react/jsx-runtime";
export const TrainingAndServicesLink = () => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/_jsx(AccountExtraLink, {
    id: "trainingAndServices",
    link: getTrainingAndServicesLink(),
    linkText: t('nav.tools.trainingAndServices'),
    isExternal: true
  });
};